import {
  COMPLETE_RESET_TOUR_STATE,
  RESET_TOUR_STATE,
  UPDATE_PRODUCT_TOUR,
} from "../types";

const initialState = {
  editLoyaltyTour: {
    seen: false,
    step: "theme", // previously seen step
  },
  campaignTour1: {
    seen: false,
    step: 1,
  },
  campaignTour2: {
    seen: false,
    step: 1,
  },
  campaignTour3: {
    seen: false,
  },
  lowCredsAlert: {
    seen: false,
  },
  newFeature: {
    for: "", // unique_key
    seen: false,
  },
  cmsProductUpdates: {},
  campaignBannerUpdates: {
    for: "", // unique_key
    closed: false,
  },
  mobileMandatory: {
    showAfterTime: "",
  },
  dashboardStatusCard: {
    hide: false,
    for: "",
  },
  educatePetpoojaCard: {
    hide: false,
    for: "",
  },
  negFbActionBanner: {
    hide: false,
    for: "",
  },
  posFlags: {
    for: "",
    flags: [],
  },
  acRemindersActionBanner: {
    hide: false,
    for: "",
  },
  categoryTemplateUpdates: {
    for: "",
    closed: false,
  },
  membershipWaitlist: {
    joined: false,
    for: "",
  },
  kycActivation: {
    for: "",
    closed: false,
  },
  membershipTeamMemberPreviewCard: {
    entityId: "",
    text_color: "",
    theme_color: "",
  },
  educate2WayWaSeen: false,
  writeWithAIBtnTooltip: false,
  educateNegFbActionSeen: false,
  educateSmartSegmentSeen: false,
  educateInviteTeamTooltipSeen: true,
  educateExcludePaymentSeen: false,
  educateCloneTemplateSeenInCamp: false,
  educateCloneTemplateSeenInAutoCamp: false,
  educateCampaignCarouselSeen: false,
  educateCampaignRecommendationModalSeen: false,
  accountEmail: "", // if this value dosen't match the previous value than reset state completely
  pricingPopups: {
    freeTrial: "", // update last 3 dates of free_trial.
    foreverFree: {
      // open popup when users are in forever free for first time (i.e. seen === false)
      // or for third time login in forever free (i.e. timesShown === 3)
      seen: false,
      timesShown: 0, // increament every time user opens app in forever free
    },
    growth: {
      Day15th: false,
      last7thDay: false,
      last3rdDays: false,
      gracepopup: "", // daily update date when users are in growth overdue status
    },
    foreverFreeAfterPaidPlan: false,
  },
};

const resetStatePayload = {
  editLoyaltyTour: {
    seen: false,
    step: "theme",
  },
  campaignTour1: {
    seen: false,
    step: 1,
  },
  campaignTour2: {
    seen: false,
    step: 1,
  },
  campaignTour3: {
    seen: false,
  },
  lowCredsAlert: {
    seen: false,
  },
};

const productTourReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PRODUCT_TOUR:
      return {
        ...state,
        [action.key]: action.payload,
      };
    case RESET_TOUR_STATE:
      return {
        ...state,
        ...resetStatePayload,
      };
    case COMPLETE_RESET_TOUR_STATE:
      return initialState;
    default:
      return state;
  }
};

export default productTourReducer;

